import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from 'src/app/components/icon/icon.module';

import { SharedModule } from '../../shared/shared.module';
import { HeaderComponent } from './header.component';
import { ButtonModule } from '../button/button.module';

@NgModule({
  imports: [CommonModule, IconModule, SharedModule, ButtonModule],
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
})
export class HeaderModule {}
